import React from 'react';
export const StatsBar = () => {
  return <div className="border-y border-legal-700 bg-legal-800/50 py-8" data-id="element-226">
      <div className="container mx-auto px-4" data-id="element-227">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x-0 md:divide-x divide-legal-700" data-id="element-228">
          <div className="flex flex-col items-center justify-center" data-id="element-229">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-230">⭐ 4.9</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-231">
              500+ ventas
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-232">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-233">100</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-234">
              Modelos editables
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-235">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-236">2026</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-237">
              Jurisprudencia actual
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-238">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-239">7 días</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-240">
              Garantía total
            </span>
          </div>
        </div>
      </div>
    </div>;
};